import { createContext } from 'react'

const NewsTipContext = createContext()

export default NewsTipContext
